module.exports = __webpack_public_path__ + "img/avi.3408d367.svg";